// Exported here for testing
export const PRINTOS_SELECTOR = 'printos-header';

// Allows for mocking in tests
export function isDocumentLoading() {
  return document.readyState === 'loading';
}
